import styled from "styled-components";

type Props = {
    isMultiline?: boolean;
};

export const DescriptionGridItemValue = styled.div<Props>`
    font-size: 1rem;
    line-height: 1.2;

    ${({ isMultiline }) =>
        isMultiline
            ? `
        white-space: pre-wrap;
        word-break: break-word;
    `
            : `
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    `}
`;
